import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { SITE_CONFIG } from "../config/siteConfig";
import { POLICY_GROUPS } from "../config/policyConfig";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column footer-location">
          <h3 className="footer-heading">Customer care</h3>
          <p>{SITE_CONFIG.operatingRegion}</p>
          <p><a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a></p>
          {SITE_CONFIG.address && <p className="address">{SITE_CONFIG.address}</p>}
          <p className="footer-note">Service times are handled in {SITE_CONFIG.timeZone}.</p>
        </div>
        <div className="footer-column footer-about">
          <h3 className="footer-heading">Shop information</h3>
          <ul className="footer-links footer-links--primary">
            <li><Link onClick={toTop} to="/about">Who We Are</Link></li>
            <li><Link onClick={toTop} to="/contact">Contact</Link></li>
            <li><Link onClick={toTop} to="/policies">All policies</Link></li>
          </ul>
        </div>
        {POLICY_GROUPS.map((group) => (
          <div className="footer-column footer-policy-group" key={group.title}>
            <h3 className="footer-heading">{group.title}</h3>
            <ul className="footer-links">
              {group.links.map(([label, path]) => (
                <li key={path}><Link onClick={toTop} to={path}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-middle">
        <div className="payment-methods" aria-label="Supported payment method">
          <svg viewBox="0 0 38 26" aria-hidden="true">
            <rect x="1" y="1" width="36" height="24" rx="4" />
            <path d="M1 8h36M6 18h9" />
          </svg>
          <span>{SITE_CONFIG.paymentMethod}</span>
        </div>
        <p>Payment details are entered only on the hosted checkout page.</p>
      </div>
      <div className="footer-bottom">
        <div className="copyright">
          © {new Date().getFullYear()} {SITE_CONFIG.brand} · Prices in {SITE_CONFIG.currency}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
